import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConstantsService } from '../constants.service';

@Injectable({
	providedIn: 'root'
})
export class InvoicesService {

	constructor(private readonly http: HttpClient, private readonly constantsService: ConstantsService) { }

loadInvoicesData(): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/export/docCtrl/invoices`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError));
	}
	//.get(`${this.constantsService.baseAPIURL}/export/docCtrl/invoices`, this.constantsService.httpCustomOptions)


	private handleError(error: HttpErrorResponse) {
		return throwError(error.message || "Server Error");
	}



}
